import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Drawer, Box, Typography, Button, Stack } from "@mui/material";
import { List, ListItemIcon, ListItemText, Collapse } from "@mui/material";
import { ExpandMore, ExpandLess, Close } from "@mui/icons-material";
import styled from "styled-components";
import Logo from "../../assests/logo/hipship.png";
import { sideBarMenus } from "../../common/data";

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  text-decoration: none;
  margin: 2px 10px;
  /* color: #dde6ed; */
  color: #151515;

  &:hover,
  &:active,
  &.active:link,
  &.active:visited {
    /* color: #3ba4d4; */
    /* color: #0e1f2e; */
    color: #fff;
    /* background-color: #f8fafd; */
    background-color: #37bc9b;

    box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.5);

    /* background-color: #37bc9b; */
    border-radius: 10px;

    > div svg {
      /* color: #0e1f2e !important; */
      color: #151515 !important;
    }
  }
`;

const StyledInsideNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  padding-left: 70px;
  text-decoration: none;
  margin: 2px 10px;
  /* color: #dde6ed; */
  color: #151515;

  &:hover,
  &:active,
  &.active:link,
  &.active:visited {
    /* color: #3ba4d4; */
    color: #fff;
    /* background-color: #f8fafd; */
    background-color: #37bc9b;
    border-radius: 10px;
  }
`;

const MobileSidebar = ({
  width,
  setWidth,
}: {
  width: string;
  setWidth: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [open, setOpen] = useState<number | null>(null);

  const handleClick = (index: number) =>
    index === open ? setOpen(0) : setOpen(index);

  const handleExtraMenu = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    index: number
  ) => {
    e.preventDefault();
    index === open ? setOpen(0) : setOpen(index);
  };

  return (
    <Drawer variant="permanent">
      <Box
        sx={{
          width: width,
          height: "100%",
          background: "#fff",
          overflow: "hidden",
          transition: "ease-in-out 0.4s",
        }}
      >
        <Box
          sx={{
            width: width,
            height: "60px",
            background: "#37bc9b",
            boxShadow: "1px 2px 7px 0px rgba(0, 0, 0, 0.1)",
            transition: "ease-in-out 0.4s",
          }}
        >
          <Stack
            direction={"row"}
            height={"100%"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <NavLink to="/" className={"no-hover"}>
              <img
                draggable={false}
                src={Logo}
                alt=""
                style={{
                  width: "60%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </NavLink>

            <Button onClick={() => setWidth("0px")}>
              <Close />
            </Button>
          </Stack>
        </Box>

        <div
          style={{
            padding: "20px 0",
            overflowX: "hidden",
            overflowY: "scroll",
            height: "calc(100vh - 60px)",
          }}
        >
          <List>
            {sideBarMenus.map((item, index) =>
              item.inside.length === 0 ? (
                <StyledNavLink
                  onClick={() => {
                    handleClick(index);
                    setWidth("0px");
                  }}
                  key={index}
                  to={item.path}
                >
                  <ListItemIcon>{item.icon} </ListItemIcon>
                  <ListItemText>
                    <Typography
                      sx={{
                        display: `${true ? "block" : "none"}`,
                      }}
                      fontSize={"14px"}
                      color={"inherit"}
                    >
                      {item.name}
                    </Typography>
                  </ListItemText>
                </StyledNavLink>
              ) : (
                <div key={index}>
                  <StyledNavLink
                    to={item.path}
                    onClick={(e) => handleExtraMenu(e, index)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                      }}
                    >
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <Typography
                        sx={{
                          display: `${true ? "block" : "none"}`,
                        }}
                        color={"inherit"}
                        fontSize={"14px"}
                      >
                        {item.name}
                      </Typography>
                    </Box>
                    <div
                      style={{
                        display: `${true ? "block" : "none"}`,
                      }}
                    >
                      {open === index ? <ExpandLess /> : <ExpandMore />}
                    </div>
                  </StyledNavLink>
                  <Collapse in={open === index} timeout="auto" unmountOnExit>
                    <List
                      sx={{
                        display: `${true ? "block" : "none"}`,
                      }}
                      component="div"
                      disablePadding
                    >
                      {item.inside.map((insideItem, insideIndex) => {
                        return (
                          <StyledInsideNavLink
                            key={insideItem.path}
                            to={`${item.path}/${insideItem.path}`}
                            onClick={() => setWidth("0px")}
                          >
                            <Typography fontSize={"13.5px"} color={"inherit"}>
                              {insideItem.name}
                            </Typography>
                          </StyledInsideNavLink>
                        );
                      })}
                    </List>
                  </Collapse>
                </div>
              )
            )}
          </List>
        </div>
      </Box>
    </Drawer>
  );
};

export default MobileSidebar;
